import {Component, Injector, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {TagTextData} from "../tag-text/tag-text.component";
import { AbstractComponent } from '../abstract.component';
import { Module } from "../../model/ModuleModel";
import { ModulesFilterService } from 'projects/common/services/modules-filter.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'input-text-filter',
    template: `
        <div [ngClass]="{'eva-3-container': module.data.ubication !== 'BODY'}">

            <text *ngIf="module.title" [data]="module" [ngClass]="{'-eva-3-mb-xxlg': module.data.ubication === 'BODY'}"></text>

            <div class="eva-3-input -lg filter-input">
              <div class="input-container">
                <input #input class="input-tag" type="text" [placeholder]="module.data.placeholder" (keyup)="onFilterChange(input.value)" id="eva-input">
              </div>
            </div>

            <div *ngIf="showNoResults" class="-eva-3-mt-md -eva-3-mb-md no-results">
              <empty-state [text]="module.data.no_result_text"
                           [title]="module.data.no_result_title">
              </empty-state>
            </div>
        </div>
    `,
    styleUrls: ['./input-text-filter.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InputTextFilterComponent extends AbstractComponent implements OnInit, OnDestroy {
    @Input() moduleId: string;
    @Input() module: Module<InputTextFilterModel>;

    filterText: string;
    showNoResults: boolean;
    private noResultsSubscription: Subscription;

    constructor(injector: Injector, private modulesFilterService: ModulesFilterService) {
      super(injector);
    }

    ngOnInit(): void {  
      this.noResultsSubscription = this.modulesFilterService.noResults$.subscribe((noResults) => {
        this.showNoResults = noResults;
      });
    }

    ngOnDestroy(): void {
      if (this.noResultsSubscription) {
        this.noResultsSubscription.unsubscribe();
      }
    }

    onFilterChange(value: string): void {
      this.modulesFilterService.filterModules(value);
    }

    getModuleId(): string {
      return this.moduleId;
    }
}

interface InputTextFilterModel {
  no_result_title: TagTextData;
  no_result_text: string;
  placeholder: string;
  items: any[];
  ubication: string;
}
